module.exports = __webpack_public_path__ + "img/master_visa_ccv.6397bd0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/master_visa_ccv.png
// module id = ./assets/img/master_visa_ccv.png
// module chunks = 9